var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1328 12.3047L15.2578 11.1797C15.4336 11.0039 15.75 11.1445 15.75 11.3906V16.4883C15.75 17.4375 14.9766 18.1758 14.0625 18.1758H1.6875C0.738281 18.1758 0 17.4375 0 16.4883V4.11328C0 3.19922 0.738281 2.42578 1.6875 2.42578H11.2852C11.5312 2.42578 11.6719 2.74219 11.4961 2.91797L10.3711 4.04297C10.3008 4.11328 10.2305 4.11328 10.1602 4.11328H1.6875V16.4883H14.0625V12.5156C14.0625 12.4453 14.0625 12.375 14.1328 12.3047ZM19.6172 5.23828L10.4062 14.4492L7.20703 14.8008C6.29297 14.9062 5.51953 14.1328 5.625 13.2188L5.97656 10.0195L15.1875 0.808594C15.9961 0 17.2969 0 18.1055 0.808594L19.6172 2.32031C20.4258 3.12891 20.4258 4.42969 19.6172 5.23828ZM16.1719 6.29297L14.1328 4.25391L7.59375 10.793L7.3125 13.1133L9.63281 12.832L16.1719 6.29297ZM18.4219 3.51562L16.9102 2.00391C16.7695 1.82812 16.5234 1.82812 16.3828 2.00391L15.3281 3.05859L17.3672 5.13281L18.457 4.04297C18.5977 3.86719 18.5977 3.65625 18.4219 3.51562Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/edit-black.50973008de96deeeddf6a3ada52e4425.svg";
export { ForwardRef as ReactComponent };